// utils/iconImageMap.js
export const ICON_IMAGE_URLS = {
  code: "https://www.denisbitter.de/images/icons/code-min.png",
  css3: "https://www.denisbitter.de/images/icons/css3-min.png",
  globe: "https://www.denisbitter.de/images/icons/globe-min.png",
  react: "https://www.denisbitter.de/images/icons/react-min.png",
  "3d": "https://www.denisbitter.de/images/icons/3d-min.png",
  javascript: "https://www.denisbitter.de/images/icons/js-min.png",
  default: "https://www.denisbitter.de/images/icons/default-min.png",
  ki: "https://www.denisbitter.de/images/icons/ki-min.png",
    video: "https://www.denisbitter.de/images/icons/video-min.png",
    c4d: "https://www.denisbitter.de/images/icons/c4d-min.png",
    "2d": "https://www.denisbitter.de/images/icons/2d-min.png",
    blender: "https://www.denisbitter.de/images/icons/blender-min.png",
  aftereffects: "https://www.denisbitter.de/images/icons/ae-min.png",
  premiere: "https://www.denisbitter.de/images/icons/premiere-min.png",
};